import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-3 flex items-center justify-center" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "p-2" }
const _hoisted_4 = { class: "text-center text-xs xs:text-sm lg:text-base xl:text-lg" }

import DevelopedByWithLogo from '@/components/App/DevelopedByWithLogo.vue';
import SocialLink from '@/components/App/Footer/SocialLink.vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoggedFooter',
  setup(__props) {


const currentYear = new Date().getFullYear();
const appName = useStore.backend.clientCompany.name;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SocialLink)
    ]),
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, " Copyright © " + _toDisplayString(_unref(currentYear)) + " " + _toDisplayString(_unref(appName)) + ", all rights reserved ", 1),
        _createVNode(DevelopedByWithLogo, { class: "mt-2" })
      ])
    ])
  ], 64))
}
}

})